import { g as l } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as o, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconJiraServiceDesk",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], f = ["fill"], p = ["id"];
function _(a, t, s, g, h, i) {
  return n(), d("svg", {
    "aria-label": s.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--jira-service-desk"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Jira Service Desk",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("path", {
      d: "m13.322 9.894 5.441.034a.848.848 0 0 1 .674 1.358L11.407 22a5.707 5.707 0 0 1-1.155-7.983l3.07-4.123Z",
      fill: `url(#${a.uniqueID}a)`
    }, null, 8, f),
    t[1] || (t[1] = e("path", {
      d: "m10.25 14.007-5.408-.034a.848.848 0 0 1-.674-1.355L12.118 2a5.707 5.707 0 0 1 1.154 7.983l-3.022 4.024Z",
      fill: "#2684FF"
    }, null, -1)),
    e("defs", null, [
      e("linearGradient", {
        id: `${a.uniqueID}a`,
        x1: "13.109",
        y1: "10.695",
        x2: "15.395",
        y2: "17.607",
        gradientUnits: "userSpaceOnUse"
      }, [...t[0] || (t[0] = [
        e("stop", { "stop-color": "#0052CC" }, null, -1),
        e("stop", {
          offset: "1",
          "stop-color": "#2684FF"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, m);
}
const q = /* @__PURE__ */ u(c, [["render", _]]);
export {
  q as default
};
//# sourceMappingURL=jira-service-desk.js.map
